<template>
    <v-card v-bind="$attrs" width="390" max-width="100%" class="event-card" @click="$emit('click')">
        <v-img :src="image+'.png'" width="100%" :aspect-ratio="390 / 317" class="mx-auto" />
        <v-img :src="image+'-active.svg'" width="100%" :aspect-ratio="390 / 317" class="event-card__active event-card__active--img mx-auto" />
        <v-img :src="image+'-active-text.svg'" width="100%" :aspect-ratio="390 / 317" class="event-card__active event-card__active--text mx-auto" />
    </v-card>
</template>

<script>

export default {
    props: {
        image: { type: String, default: "" },
    },
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";

.event-card{
    position: relative;
    &__active{
        position: absolute;
        top: 0;
        left: 0;
        &--img{
            opacity: 0;
            visibility: hidden;
            transition: 0.3s ease-out;
        }
        &--text{
            opacity: 0;
            visibility: hidden;
            transform: translateY(40%);
            transition: transform 0.01s 0.3s ease-out, opacity 0.3s ease-out, visibility 0.3s ease-out;
        }
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .event-card{
        &:hover{
            .event-card__active--img{
                opacity: 0.5;
                visibility: visible;
            }
            .event-card__active--text{
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
                transition: transform 0.5s ease-out, opacity 0.5s 0.3s ease-out, visibility 0.5s 0.3s ease-out;
            }
        }
    }
}
@media (min-width:1200px){
}

</style>